import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import StyledEntitiesTableBar from 'components/organisms/Bars/EntitiesTableBar/EntitiesTableBar.styles';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';
import useMediaQuery from '@mui/material/useMediaQuery';

const EntitiesTableBar = React.forwardRef((props, ref) => {
  const {
    isDealflow,
    saveAction,
    filterAction,
    columnAction,
    assistantAction,
    ...innerProps
  } = useComponentProps(props, 'EntitiesTableBar');

  const tableProvider = useTable();

  const xsDown = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const smDown = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const searchField = useMemo(() => ({
    placeholder: 'Search for a company'
  }), []);

  const saveActionMemo = useMemo(() => ({
    auth: utils.createAuth({ attribute: 'entity.save'}),
    ...saveAction
  }), [saveAction]);

  const assistantActionMemo = useMemo(() => ({
    auth: utils.createAuth({ attribute: 'entity.assistant'}),
    ...assistantAction
  }), [assistantAction]);

  const filterActionMemo = useMemo(() => ({
    auth: utils.createAuth({ attribute: 'entity.filters'}),
    ...filterAction
  }), [filterAction]);

  const columnActionMemo = useMemo(() => ({
    auth: utils.createAuth({ attribute: 'entity.columns'}),
    ...columnAction
  }), [columnAction]);

  const entitiesCount = utils.formatNumber(tableProvider.list?.meta?.resultsCount ?? 0);

  innerProps.title = innerProps.title ?? (xsDown ? entitiesCount :
    `${entitiesCount} compan${(tableProvider.list?.meta?.resultsCount ?? 0) === 1 ? 'y' : 'ies'}`);

  innerProps.hideColumn = innerProps.hideColumn ?? smDown;
  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledEntitiesTableBar ref={ref} {...innerProps}
                                 searchField={searchField}
                                 saveAction={saveActionMemo}
                                 assistantAction={assistantActionMemo}
                                 filterAction={filterActionMemo}
                                 columnAction={columnActionMemo}>
    {innerProps.children}
  </StyledEntitiesTableBar>
});

EntitiesTableBar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  isDealflow: PropTypes.bool,
  saveAction: PropTypes.object,
  filterAction: PropTypes.object,
  columnAction: PropTypes.object,
  assistantAction: PropTypes.object
};

export default EntitiesTableBar;
